"use client";

import React from "react";
import SubNavigationItem, {
    SubNavigationItemType,
} from "./SubNavigationItemOld";
import Link from "next/link";

type Props = {
    name: string;
    titleHref?: string;
    items: SubNavigationItemType[];
    children?: React.ReactNode;
};

const SubNavigationGroup = ({ name, titleHref, items, children }: Props) => {
    return (
        <div className="flex flex-col gap-3 p-4">
            {titleHref ? (
                <Link
                    href={titleHref}
                    className="font-[500] uppercase tracking-wider"
                >
                    {name}
                </Link>
            ) : (
                <p className="font-semibold uppercase">{name}</p>
            )}

            {children}

            {items.map((item) => {
                return <SubNavigationItem key={item.name} {...item} />;
            })}
        </div>
    );
};

export default SubNavigationGroup;
